import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check, Mail } from "lucide-react";

export default function TriggerEmailSection({ trigger }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const emailConfig = (trigger.config || []).find((c) => c.key === "emailAddress");
    const emailAddress = emailConfig?.value || `${trigger.publicKey}@trigger.agentui.ai`;

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(emailAddress);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }, [emailAddress]);

    return (
        <div className="p-4 space-y-4">
            <div>
                <label className="text-xs font-medium text-gray-700 block mb-1">{t("chatInput.emailAddressLabel")}</label>
                <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-lg p-2">
                    <Mail size={14} className="text-gray-400 flex-shrink-0" />
                    <code className="text-xs text-gray-700 break-all flex-1">{emailAddress}</code>
                    <button onClick={handleCopy} className="p-1 hover:bg-gray-200 rounded flex-shrink-0">
                        {copied ? <Check size={14} className="text-green-500" /> : <Copy size={14} className="text-gray-400" />}
                    </button>
                </div>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700">
                    {t("chatInput.emailTriggerHelp")}
                </p>
            </div>
        </div>
    );
}
